import React from "react";
import FinecoPieChart from "./components/FinecoPieChart";
import { PortfolioElementType } from "types/PortfolioTypes";
import styles from "./portfolioTablePie.module.scss";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import FinecoTable from "./components/FinecoTable";
type Props = { dataItem: PortfolioElementType; subSection?: boolean };
const PortfolioTablePie: React.FC<Props> = ({ dataItem, subSection }) => {
  return (
    <>
      {!subSection && (
        <h3 className={commonStyles.titleChart}>{dataItem.configData.label}</h3>
      )}
      {subSection && (
        <div className={commonStyles.subtitleChart}>
          {dataItem.configData.label}
        </div>
      )}
      <div className={styles.portfolioDistribution}>
        <FinecoTable dataObject={dataItem} />
        <FinecoPieChart dataItem={dataItem} />
      </div>
    </>
  );
};

export default PortfolioTablePie;
